/**
 * Responsive media query helpers for styled-components.
 * Usage:
 *   import { media } from '@/styles/responsive';
 *   const MyDiv = styled.div`
 *     padding: 24px;
 *     ${media.mobile} { padding: 16px; }
 *   `;
 */

export const BREAKPOINTS = {
  sm: 480,
  md: 768,
  lg: 992,
  xl: 1200,
} as const;

export const media = {
  mobile: `@media (max-width: ${BREAKPOINTS.md - 1}px)`,
  tablet: `@media (min-width: ${BREAKPOINTS.md}px) and (max-width: ${BREAKPOINTS.lg - 1}px)`,
  desktop: `@media (min-width: ${BREAKPOINTS.lg}px)`,
  notDesktop: `@media (max-width: ${BREAKPOINTS.lg - 1}px)`,
  notMobile: `@media (min-width: ${BREAKPOINTS.md}px)`,
} as const;
